module.exports = __webpack_public_path__ + "media/newstyle/images/congratulations-de-0945e254efa64479dd2598c2a18dcda4.png";